exports.components = {
  "component---src-templates-pokemon-list-tsx": () => import("./../../../src/templates/PokemonList.tsx" /* webpackChunkName: "component---src-templates-pokemon-list-tsx" */),
  "component---src-templates-single-pokemon-js": () => import("./../../../src/templates/SinglePokemon.js" /* webpackChunkName: "component---src-templates-single-pokemon-js" */)
}

